<template>
	<div class="app-container">
		<el-tabs ref="tabs" type="border-card" v-model="activeName" v-tab-change:activeName="setActiveName">
			<!-- 用户管理 -->
			<el-tab-pane label="用户管理" name="userList">
				<UserList></UserList>
			</el-tab-pane>

			<!-- 用户认证 -->
			<el-tab-pane name="expertReq">
				<template #label>
					<span>普通专家认证</span>
					<el-badge v-if="newMsg.expertAuthenticationNo > 0" :value="newMsg.expertAuthenticationNo">
					</el-badge>
				</template>
				<UserExpertReqView></UserExpertReqView>
			</el-tab-pane>

			<!-- 会诊专家认证 -->
			<el-tab-pane ref="diagnosisTab" v-if="isShowDiagnosisManagement()" name="consultation">
				<template #label>
					<span>会诊专家认证</span>
					<el-badge v-if="newMsg.consultationAuthenticationNo > 0"
						:value="newMsg.consultationAuthenticationNo"></el-badge>
				</template>
				<consultation-apply-view />
			</el-tab-pane>

			<el-tab-pane ref="userReviewTab" v-if="isShowUserReviewTab()" label="产品用户认证" name="userReview">
				<user-review />
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import consultationApplyView from "@/views/systemManagement/userManagement/UserAuthentication/consultationUserReqView.vue"
	import UserReview from '@/components/FileManagement/User/userReview'
	import UserList from '@/views/systemManagement/userManagement/userDetail/userList.vue'
	// import UserExpertReqView from "@/views/systemManagement/userManagement/UserAuthentication/UserExpertReqView.vue"
	import UserExpertReqView from "@/views/systemManagement/expertManagement/index"
	import {
		mapGetters
	} from "vuex";
  import {printObj} from "@/utils/debug";
  import {
    isVaild
  } from "@/utils/validate";
  import config from "@/utils/config";

  export default {
		components: {
			consultationApplyView,
			UserReview,
			UserList,
			UserExpertReqView
		},
		computed: {
			...mapGetters(['newMsg']),
		},
    methods:{
      isShowDiagnosisManagement(){
        //v-if 无效，自己设置样式
        // this.$nextTick(() => {
        //   //console.log("config " +this.config.SHOW_DIAGNOSIS_TAB)
        //   if(this.config.SHOW_DIAGNOSIS_TAB !== "true" ){
        //     this.$refs.tabs.$children[0].$refs.tabs[2].hidden = true;
        //   }
        // })
        return this.config.SHOW_DIAGNOSIS_TAB === "true";
      },
      isShowUserReviewTab(){
        return this.config.SHOW_USER_REVIEW_TAB === "true";
      }
    },
    data(){
      return {
        activeName:"userList"
      }
    }
	}
</script>

<style scoped lang="scss">
	.detail {
		display: flex;
		flex-direction: row;

		&-left,
		&-right {
			display: flex;
			flex-direction: column;
			width: 50%;
			padding: 0 20px;

			span {
				min-height: 20px;
				line-height: 20px;
				margin-bottom: 20px;
			}

			img {
				cursor: pointer;
			}
		}
	}
</style>
